import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=87cc6714&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=ts"
export * from "./LinkButton.vue?vue&type=script&lang=ts"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=87cc6714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc6714",
  null
  
)

export default component.exports